import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=35ac8cc0&scoped=true"
import script from "./Contratos.vue?vue&type=script&lang=js"
export * from "./Contratos.vue?vue&type=script&lang=js"
import style0 from "./Contratos.vue?vue&type=style&index=0&id=35ac8cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac8cc0",
  null
  
)

export default component.exports